<script lang="ts">
  import {onMount, afterUpdate, onDestroy} from 'svelte';
  import {portal} from 'svelte-portal';
  import type {Sizes, Styles} from 'Types/common/portalTypes';

  export let sizes: Sizes = {width: 0, height: 0, yPadding: 0};

  let wrapper: HTMLElement;
  let portalElement: HTMLElement;
  let styles: Styles = {
    width: `${sizes.width}px`,
    height: `${sizes.height}px`,
    top: '0',
    left: '0',
  };

  const loaded = (): void => {
    if (wrapper) {
      const rect = wrapper.getBoundingClientRect();
      styles = {
        width: `${sizes.width}px`,
        height: `${sizes.height}px`,
        top: `${rect.top + window.scrollY}px`,
        left: `${rect.left + window.scrollX + sizes.yPadding}px`,
      };
    }
  };

  onMount(() => {
    loaded();
    window.addEventListener('resize', loaded);
  });

  afterUpdate(loaded);

  onDestroy(() => {
    window.removeEventListener('resize', loaded);
  });
</script>

<div
  bind:this={wrapper}
  style="width: {styles.width}; height: {styles.height};"
  data-testId="content-wrapper"
>
  <div use:portal bind:this={portalElement} data-testId="portal-component">
    <div
      style="position: absolute; top: {styles.top}; left: {styles.left}; width: {styles.width}; height: {styles.height};"
      data-testId="reposition-portal"
    >
      <slot />
    </div>
  </div>
</div>
